export function Pagination({ page, totalPages, total, itemLabel = "items", onPageChange }) {
  const summary =
    total === 0
      ? `No ${itemLabel}`
      : `Page ${page} of ${totalPages} · ${total} ${total === 1 ? itemLabel.replace(/s$/, "") : itemLabel}`;

  return (
    <nav className="pagination" aria-label={`${itemLabel} pagination`}>
      <button
        type="button"
        className="pagination__button"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
      >
        ← Previous
      </button>

      {/* Announced when the page changes so it isn't a silent update. */}
      <span className="pagination__summary" aria-live="polite">
        {summary}
      </span>

      <button
        type="button"
        className="pagination__button"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
      >
        Next →
      </button>
    </nav>
  );
}
